import { Link } from "react-router-dom";
import { LifeBuoy } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="mt-20 border-t border-slate-200 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <span className="grid place-items-center w-8 h-8 rounded-lg bg-[#1A73E8] text-white">
            <LifeBuoy className="w-4 h-4" />
          </span>
          <span className="font-heading font-semibold text-slate-800">Gsupport Help Center</span>
        </div>
        <p className="text-sm text-slate-500 flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
          <Link to="/search" className="text-[#1A73E8] hover:underline font-medium">Search articles</Link>
          <Link to="/support" data-testid="footer-support-link" className="text-[#1A73E8] hover:underline font-medium">Contact support</Link>
          <Link to="/cancel" data-testid="footer-cancel-link" className="text-[#1A73E8] hover:underline font-medium">Cancel plan</Link>
        </p>
        <p className="text-xs text-slate-400">© {new Date().getFullYear()} Gsupport</p>
      </div>
    </footer>
  );
};
